module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonecvm-04.84ce8f8f.jpg";